import React, { useState, useEffect } from 'react';
import { useField } from 'formik';
import { useSnackbar } from 'notistack';
import SelectField from '../../../../../../web-app-components/components/SelectField';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';

import categoriesClient from '../../../../../../clients/categories';
import SubcategorySelectField from '../SubcategorySelectField';

const useStyles = makeStyles((theme) => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
}));

const CategoriesSelectField = (props) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [field, , helpers] = useField(props.name);
  const [, , subcategoriesHelpers] = useField('subcategories');

  const [categories, setCategories] = useState();

  useEffect(() => {
    (async () => {
      try {
        setCategories(await categoriesClient.find({ _sort: 'Order:asc' }));
      } catch (error) {
        enqueueSnackbar(
          'Nepavyko gauti objektų kategorijų. Bandykite atidaryti iš naujo.',
          { variant: 'error' }
        );
      }
    })();
  }, [enqueueSnackbar]);

  // Ensure value is a single value (not an array)
  useEffect(() => {
    if (Array.isArray(field.value)) {
      // If it's an array, take the first value or null
      helpers.setValue(field.value.length > 0 ? field.value[0] : null);
    } else if (field.value === undefined) {
      helpers.setValue(null);
    }
  }, [field.value, helpers]);

  const selectedCategory = field.value;
  const selectedCategoryData = categories
    ? categories.find((c) => c.id === selectedCategory)
    : null;

  const showSubcategoryField = selectedCategoryData && selectedCategoryData.hasSubcategories;

  // Clear subcategories when no category with subcategories is selected
  useEffect(() => {
    if (!showSubcategoryField && subcategoriesHelpers.value && subcategoriesHelpers.value.length > 0) {
      subcategoriesHelpers.setValue([]);
    }
  }, [showSubcategoryField, subcategoriesHelpers]);

  const renderValue = (selected) => {
    if (selected == null || selected === '') return null;
    const item = categories?.find((c) => c.id === selected);
    if (!item) return selected;
    return (
      <Box className={classes.chips}>
        <Chip key={item.id} label={item.Title || ''} size="small" />
      </Box>
    );
  };

  return (
    <>
      {categories ? (
        <SelectField {...props} renderValue={renderValue}>
          {categories.map(({ id, Title }) => (
            <MenuItem key={id} value={id}>
              {Title}
            </MenuItem>
          ))}
        </SelectField>
      ) : (
        <CircularProgress />
      )}
      {showSubcategoryField && (
        <SubcategorySelectField
          name="subcategories"
          label="Subkategorijos"
          fullWidth={props.fullWidth}
          categoryId={selectedCategory}
        />
      )}
    </>
  );
};

export default CategoriesSelectField;
